import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-file-upload-progress',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './file-upload-progress.component.html',
  styleUrls: ['./file-upload-progress.component.css']
})
export class FileUploadProgressComponent {
  @Input() fileName: string = '';
  @Input() fileSize: string = '';
  @Input() progress: number = 0;
  @Input() isUploading: boolean = false;
  @Output() cancelUpload = new EventEmitter<void>();

  Math = Math;

  onCancel(): void {
    this.cancelUpload.emit();
  }
}
